export const environment = {
  production: true,
  getResellersUrl: 'https://proclient4.beta.biz/BetaTools.ProClient.Web/Services/WhereToBuy.svc/GetResellers',
  sendWishListToDealerUrl: 'https://proclient4.beta.biz/BetaTools.ProClient.Web/Services/WhereToBuy.svc/SendWishListToDealer',
  sendWishListUrl: 'https://proclient4.beta.biz/BetaTools.ProClient.Web/Services/WhereToBuy.svc/SendWishList',
  backToWishListUrl: 'https://beta-tools.it',
  captchaImageUrl: 'https://proclient4.beta.biz/BetaTools.ProClient.Web/Services/Captcha.ashx?time=',
  getWishListUrl: 'https://proclient4.beta.biz/BetaTools.ProClient.Web/Services/WhereToBuy.svc/GetWishList'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts